export default "__VITE_ASSET__B37vo1RB__"